import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Checkup, CheckupComparison } from '../../models/Checkup';


@Component({
  selector: 'app-audit-hash',
  templateUrl: 'audit-hash.component.html',
  styleUrls: ['./audit-hash.component.less', '../../shared/common.less']
})

export class AuditHashComponent implements OnInit, OnChanges {
  @Input() auditComparisons: CheckupComparison[];
  @Input() lastAudit: Checkup;
  @Input() auditSuccess: boolean;
  @Output() startAuditEvent = new EventEmitter<boolean>();
  @Output() reportDownload = new EventEmitter();

  filterValue: string = 'tous';
  filteredAuditComparisons: CheckupComparison[] = [];

  ngOnInit() {
    // Initialiser les données filtrées au chargement
    this.onFilterChange();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Mettre à jour les données filtrées quand auditComparisons change
    if (changes['auditComparisons'] && this.auditComparisons) {
      this.onFilterChange();
    }
  }

  isAuditCompliant(integrity: string): string {
    if (integrity == "Intègre") {
      return 'Conforme';
    }
    return 'Non Conforme';
  }

  startAudit() {
    this.startAuditEvent.emit(true);
  }

  downloadReport() {
    this.reportDownload.emit();
  }

  getAuditDate(): string {
    if (this.lastAudit == null) {
      return '';
    }
    return new Date(this.lastAudit.time).toLocaleString();
  }

  onFilterChange() {

    if (!this.auditComparisons) {
      this.filteredAuditComparisons = [];
      return;
    }

    switch (this.filterValue) {

      case 'tous':
        this.filteredAuditComparisons = this.auditComparisons;
        break;

      case 'hash-election':
        this.filteredAuditComparisons = this.auditComparisons.filter(audit => audit.lineName === 'Hash paramètres de l\'élection');
        break;

      case 'hash-version':
        this.filteredAuditComparisons = this.auditComparisons.filter(audit => audit.lineName === 'Hash version applicative');
        break;

      case 'hash-candidats':
        this.filteredAuditComparisons = this.auditComparisons.filter(audit => audit.lineName === 'Hash liste des candidats');
        break;

      case 'hash-votants':
        this.filteredAuditComparisons = this.auditComparisons.filter(audit => audit.lineName === 'Hash liste des électeurs');
        break;

      case 'empreinte-emergement':
        this.filteredAuditComparisons = this.auditComparisons.filter(audit => audit.lineName === 'Empreinte liste d\'émargement');
        break;

      case 'empreinte-urne':
        this.filteredAuditComparisons = this.auditComparisons.filter(audit => audit.lineName === 'Empreinte urne');
        break;

      case 'coherence':
        this.filteredAuditComparisons = this.auditComparisons.filter(audit => audit.lineName === 'Cohérence urne/émargement');
        break;

      case 'hash-log':
        this.filteredAuditComparisons = this.auditComparisons.filter(audit => audit.lineName === 'Hash du journal des événements');
        break;

      default:
        this.filteredAuditComparisons = this.auditComparisons;
        break;
    }
  }
}
